import Headroom from "headroom.js";

const HeaderScroll = () => {
    var headerElement = document.querySelector(".header");
    var options = {
        classes : {
            initial : "header--init",
            pinned : "header--pinned",
            unpinned : "header--unpinned",
            top : "header--top",
            notTop : "header--not-top",
            bottom : "header--bottom",
            notBottom : "header--not-bottom",
            frozen: "header--frozen",
            pinned: "header--pinned foo bar"
        }
    };
    var headroom = new Headroom(headerElement, options);
    headroom.init();
}

export default HeaderScroll;
